import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MuiAppBar from '@mui/material/AppBar';

import Button from "./Button";
import { styled, useTheme } from '@mui/material/styles';
import { useContext, useState } from "react";
import { Menu } from "@mui/icons-material";
import UserContext from "../contexts/UserContext";
import { logout } from "../util/helpers";
import { ReactComponent as DashboardIcon} from "../assets/dashboard-icon.svg";
import { ReactComponent as CampaignsIcon} from "../assets/my-campaigns-icon.svg";
import { ReactComponent as CreatorsIcon} from "../assets/discover-creators-icon.svg";
import { ReactComponent as TrendingIcon} from "../assets/trending-icon.svg";
import { ReactComponent as MyListsIcon} from "../assets/my-list-icon.svg";
import { ReactComponent as InsightsIcon} from "../assets/insights-icon.svg";
import { ReactComponent as PlusIcon} from "../assets/plus-icon.svg";
import { IconChartDots, IconDeviceDesktopAnalytics, IconSpeakerphone, IconUsers, IconSparkles, IconEdit, IconInbox, IconCalendar, IconUsersGroup, IconPhoto } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import PostComposerDialog from "../Social/PostComposerDialog";
const drawerWidth = 280;
const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 2),
  minHeight: 64,
  justifyContent: 'space-between',
}));

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    minWidth: 0,
    overflow: 'hidden',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  }),
}));
const Layout = ({children}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const [postComposerOpen, setPostComposerOpen] = useState(false);
  const { authed, user } = useContext(UserContext);
  const isDesktop = useMediaQuery("(min-width:1000px)");
  const navigate = useNavigate();
  const socialToolEnabled = localStorage.getItem("socialToolEnabled") === "true";

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  const loginRedirect = () => {
    window.location.href = "/login";
  };
  console.log("user", user);
  if (!user) return <></>;
  let content = null;
  const isActive = (path) => {
    const p = window.location.pathname;
    if (path === "/campaigns") return p === "/campaigns" || (p.startsWith("/campaigns/") && !p.includes("creatordiscovery") && !p.includes("faq") && p !== "/campaigns/create");
    return p === path || (path !== "/dashboard" && p.startsWith(path));
  };

  const navItemSx = (path) => {
    const active = isActive(path);
    return {
      mb: 0.75,
      mx: 1.5,
      borderRadius: "12px",
      backgroundColor: active ? "rgba(159, 37, 246, 0.08)" : "transparent",
      borderLeft: active ? "3px solid #9F25F6" : "3px solid transparent",
    };
  };

  if (user.type === "creator") {
    content = (
      <List sx={{ px: 0, py: 1.5 }}>
        {[
          { label: "Dashboard", icon: IconDeviceDesktopAnalytics, path: "/creators" },
          { label: "My Account", icon: IconUsers, path: "/creators/account" },
        ].map((item) => {
          const active = isActive(item.path);
          return (
            <ListItem key={item.label} disablePadding sx={navItemSx(item.path)}>
              <ListItemButton
                onClick={() => navigate(item.path)}
                sx={{
                  py: 1.5,
                  px: 2,
                  borderRadius: "12px",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: active ? "rgba(159, 37, 246, 0.12)" : "var(--neutral-50)",
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <item.icon
                    size={22}
                    style={{
                      stroke: active ? "#7c3aed" : "var(--body-text-color-500)",
                      transition: "stroke 0.2s ease",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: active ? 600 : 500,
                    fontSize: "0.9375rem",
                    color: active ? "var(--main-text-color)" : "var(--body-text-color-600)",
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    );
  } else {
    content = (
      <>
        <Box sx={{ px: 2, pt: 2, pb: 1, display: "flex", flexDirection: "column", gap: 1 }}>
          <Button
            style={{
              width: "100%",
              borderRadius: "12px",
              padding: "10px 20px",
              fontSize: 14,
              fontWeight: 600,
              boxShadow: "0 2px 8px rgba(159, 37, 246, 0.25)",
            }}
            gradient
            onClick={() => navigate("/campaigns/create")}
          >
            <PlusIcon style={{ marginRight: 8, fontSize: 18 }} />
            Create Campaign
          </Button>
          {socialToolEnabled && (
            <Button
              style={{
                width: "100%",
                borderRadius: "12px",
                padding: "10px 20px",
                fontSize: 14,
                fontWeight: 600,
                background: "linear-gradient(135deg, #1DA1F2 0%, #9F25F6 100%)",
                color: "white",
              }}
              onClick={() => setPostComposerOpen(true)}
            >
              <IconEdit size={18} style={{ marginRight: 8 }} />
              Create a Post
            </Button>
          )}
        </Box>
        <List sx={{ px: 0, py: 1 }}>
          {[
            { label: "Dashboard", icon: IconDeviceDesktopAnalytics, path: "/dashboard" },
            { label: "My Campaigns", icon: IconSpeakerphone, path: "/campaigns" },
            { label: "Discover Creators", icon: IconUsers, path: "/campaigns/creatordiscovery" },
            { label: "Landscape & Trends", icon: IconChartDots, path: "/competitive/landscape" },
            ...(socialToolEnabled ? [
              { label: "Engagement / Inbox", icon: IconInbox, path: "/social/inbox" },
              { label: "Social Calendar", icon: IconCalendar, path: "/social/calendar" },
              { label: "Users & Groups", icon: IconUsersGroup, path: "/social/users" },
              { label: "Media & Assets", icon: IconPhoto, path: "/social/media" },
            ] : []),
            { label: "Tutorials & FAQ", icon: IconSparkles, path: "/campaigns/faq" },
          ].map((item) => {
            const active = isActive(item.path);
            return (
              <ListItem key={item.label} disablePadding sx={navItemSx(item.path)}>
                <ListItemButton
                  onClick={() => navigate(item.path)}
                  sx={{
                    py: 1.5,
                    px: 2,
                    borderRadius: "12px",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      backgroundColor: active ? "rgba(159, 37, 246, 0.12)" : "var(--neutral-50)",
                    },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <item.icon
                      size={22}
                      style={{
                        stroke: active ? "#7c3aed" : "var(--body-text-color-500)",
                        transition: "stroke 0.2s ease",
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontWeight: active ? 600 : 500,
                      fontSize: "0.9375rem",
                      color: active ? "var(--main-text-color)" : "var(--body-text-color-600)",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </>
    );
  }

  return <>
<Box sx={{ display: 'flex' }}>
<AppBar
          position="fixed"
          style={{
            background: "white",
            height: 65,
          }}
          sx={{boxShadow: "none"}}
        >
          <Toolbar style={{ width: "100%" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: 'none' }) }}
          >
            <Menu sx={{color: "black"}} />
          </IconButton>
            <Typography
              variant="h2"
              component="div"
              style={{ color: "black", cursor: "pointer" }}
              onClick={() => (window.location.href = "/")}
            >
              GIGL
            </Typography>
            <div
              style={{
                marginLeft: "auto",
                color: "black",
                cursor: "pointer",
                display: "flex",
              }}
            >
              {/* {(!authed || window.location.pathname === "/") && (
                <Typography
                  variant="body"
                  onClick={() => {
                    window.location.href = "/pricing";
                  }}
                  style={{ marginRight: isDesktop ? 50 : 10, fontSize: 12 }}
                >
                  Pricing
                </Typography>
              )} */}

              {/* <Typography
              variant="body"
              sx={{marginRight: 5}}
                onClick={
                 () => {
                  window.location.href = "/creatorhome";
                 }
                }
                style={{ marginRight: isDesktop ? 50 : 10, fontSize: 12 }}
              >
                Creator Hub
              </Typography>  */}

           

       
              <Typography
                style={{ fontSize: 12 }}
                onClick={
                  authed
                    ? () => {
                        logout();
                      }
                    : loginRedirect
                }
              >
                {authed ? "Logout" : "Login"}
              </Typography>
            </div>
          </Toolbar>
          <Divider />
        </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            borderRight: "1px solid var(--neutral-200)",
            background: "linear-gradient(180deg, #ffffff 0%, #fafbff 100%)",
            boxShadow: "4px 0 24px rgba(0,0,0,0.04)",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader
          sx={{
            minHeight: 64,
            px: 2,
            borderBottom: "1px solid var(--neutral-100)",
            background: "rgba(255,255,255,0.8)",
          }}
        >
          <Typography
            variant="h2"
            onClick={() => navigate("/")}
            sx={{
              letterSpacing: "-0.02em",
              background: "black",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              color: "transparent",
              cursor: "pointer",
            }}
          >
            GIGL
          </Typography>
          <IconButton
            onClick={handleDrawerClose}
            size="small"
            sx={{
              color: "var(--body-text-color-500)",
              "&:hover": { backgroundColor: "var(--neutral-100)", color: "var(--main-text-color)" },
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
        </DrawerHeader>
        <Box sx={{ flex: 1, overflow: "auto", py: 0 }}>{content}</Box>
      </Drawer>
      <Main open={open}>
        <DrawerHeader />
        <div style={{ backgroundColor: "#f5f5ff"}}>
       {children}
       </div>
      </Main>
      
    </Box>
    <PostComposerDialog
      open={postComposerOpen}
      onClose={() => setPostComposerOpen(false)}
      onPostCreated={(postId, opts) => {
        if (!opts?.skipNavigate) navigate(`/social/posts/${postId}`);
      }}
    />
    {/* <Box
      sx={{
        textAlign: "center",
        boxShadow: 1,
        width: "12vw",
        backgroundColor: "#f5f5f5",
        height: "110%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}
      alignItems="left"
    >
      <div style={{ gap: 15, display: "flex", flexDirection: "column", marginTop: 50, }}>

        <Button
          style={{
            borderRadius: 1,
            width: "100%",
            backgroundColor: "#4158D0",
            backgroundImage:
              "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
            fontSize: 12,
          }}
          onClick={() => navigate("/campaigns")}
        >
          My Dashboard
        </Button>

        <Button
          style={{
            borderRadius: 1,
            width: "100%",
            backgroundColor: "#4158D0",
            backgroundImage:
              "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
            fontSize: 12,
          }}
          onClick={() => navigate("/blog")}
        >
          Blog & Insights
        </Button>

        <Button
          style={{
            borderRadius: 1,
            width: "100%",
            backgroundColor: "#4158D0",
            backgroundImage:
              "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
            fontSize: 12,
          }}
          onClick={() => navigate("/campaigns/analyticsdashboard")}
        >
          Analytics
        </Button>

        <Button
          style={{
            borderRadius: 1,
            width: "100%",
            backgroundColor: "#4158D0",
            backgroundImage:
              "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
            fontSize: 12,
          }}
          onClick={() => navigate("/campaigns/creatordiscovery")}
        >
          Creator Discovery
        </Button>

        <Button
          style={{
            borderRadius: 1,
            width: "100%",
            backgroundColor: "#4158D0",
            backgroundImage:
              "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
            fontSize: 12,
          }}
          onClick={() => navigate("/competitive/landscape")}
        >
          Landscape & Trends
        </Button>
        <Button
          style={{
            borderRadius: 1,
            width: "100%",
            backgroundColor: "#4158D0",
            backgroundImage:
              "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
            fontSize: 12,
          }}
          onClick={() => navigate("/favorites")}
        >
          My Favorites
        </Button>
      </div>
      <div style={{ gap: 15, display: "flex", flexDirection: "column", marginBottom: 50}}>

        <Button
          style={{
            borderRadius: 1,
            width: "100%",
            backgroundColor: "#4158D0",
            backgroundImage:
              "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
            fontSize: 12,
          }}
          onClick={() => navigate("/campaigns/FAQ")}
        >
          Help & FAQ
        </Button>

        <Button
          style={{
            borderRadius: 1,
            width: "100%",
            fontSize: 12,
          }}
          onClick={() => navigate("/campaigns/account")}
        >
          My Account
        </Button>
      </div>
    </Box> */}
  </>

}

export default Layout;